module.exports = "/img/_/_/_/assets/images/creeper/book/common//12.jpg?376d8c3d117aceceaab8fc634f0eecf6";